
import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import T4SlipImportLayout from "../../../components/RL1Slip/RL1SlipImportLayout/RL1SlipImportLayout";

export interface IT4SlipImportPage {}

export const T4SlipImportPage: FC<IT4SlipImportPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Import T4 Slip"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Compliance", navigateTo: "/compliance/t4/list" },
        { text: "T4", navigateTo: "/compliance/t4/list" },
        { text: "Import T4 Slips", navigateTo: "/compliance/t4/import" },
      ]}
      mainContents={<T4SlipImportLayout />}
    />
  );
};
